import React from 'react';
import {Link} from "react-router";
import { existingFileError, missingFileError, existingFileErrorMessage, fileTypes } from '../../consts/consts';
import { removeFile, uploadFile } from '../../requests/fileRequests';
import Input from "../Input-new/Input";

export default class UploadFile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            file: null,
            base64URL: null,
            error: null,
            redirectLink: null,
            isBusy: false,
        };
        this.upload = this.upload.bind(this);
        this.remove = this.remove.bind(this);
        this.validateSelectedFile = this.validateSelectedFile.bind(this);
        this.getBase64 = this.getBase64.bind(this);
        this.fileInputRef = React.createRef();
    }

    componentDidMount(){
        if (this.props.link) {
            // const fileName = this.props.link.substring(this.props.link.indexOf('_') + 1);
            const fileName = this.props.link.split('/').pop();
            this.setState({
                redirectLink: this.props.link,
                file: {
                    name: fileName
                }
            });
        }
    }

    getBase64(file) {
        return new Promise(resolve => {
            let baseURL = "";
            let reader = new FileReader();

            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    }

    upload(selectedFile) {
        const fileType = this.props.fileType;
        const fileName = selectedFile.name;
        const base64File = selectedFile.base64;
        const filePath = window.location.pathname.split("/")[1];
        var FOLDER = ['website_photo_1', 'website_photo_2', 'website_photo_3', 'website_photo_4'].includes(this.props.name) ? `website/property-photos/${this.props.data.arcimedes_row_id}`: this.props.name === "media_kit" ? `website/property-packages/${this.props.data.arcimedes_row_id}`: this.props.name === "photo" ? `website/contacts/${this.props.data.contact_id}`:"property-rep-agreement-files";
        
            if (filePath.toLowerCase() === "teammember" && fileType !== "photo" ) {
                FOLDER = 'team-member';
            }
            const reqtype = fileType === "photo" ? "image" : "pdf";
        return uploadFile({fileName, base64File, folder:FOLDER,type:reqtype}).then(res => {
            this.setState({isBusy: false});
            // res = res.data.responses[0];
            res = res.data.uploadImage;
            if (!res || !res.success) {
                if (res.errorCode === existingFileError) {
                    if (fileType !== fileTypes.Photo) {
                        const fileName = this.state.file.name.split('.')[0];
                        const newName = fileName + '_' + this.props.data.ADDRESS + '.pdf';

                        this.setState({
                            file: {
                                name: newName
                            },
                        }, () => this.upload(this.props.name));
                    } else {
                        this.setState({
                            file: null,
                            error: existingFileErrorMessage,
                        });
                    }
                } else {
                    this.setState({
                        error: res && res.message ? res.message : "Unspecified error",
                    });
                }
            } else {
                const path = res.fileUrl &&  res.fileUrl.fileUrl ? res.fileUrl.fileUrl : null
                //const redirectLink = res.data.url.split('/v0/')[1];
                const redirectLink = ['website_photo_1', 'website_photo_2', 'website_photo_3', 'website_photo_4', 'media_kit', 'photo'].includes(this.props.name) ? path.split('?')[0] :res.fileUrl.s3_url;
                this.setState({
                    error: null,
                    file: selectedFile,
                    base64URL: selectedFile.base64
                })
                    const { handleChange,getPathData } = this.props;
                    handleChange(this.props.name, redirectLink);
                    getPathData(path)
               
            }
        })
    }

    remove(key) {
        const filePath = window.location.pathname.split("/")[1];
        var fileName = this.state.file.name;
        if (!fileName.includes("/")) { 
            if (filePath.toLowerCase() === "property") {
                fileName = `property-rep-agreement-files/${fileName}`;
            } else if (filePath.toLowerCase() === "teammember") {
                fileName = `team-member/${fileName}`;
            }
        }
        removeFile(fileName).then(res => {

            // if (!res || !res.success) {
                if (!res || !res.data.deleteImage.success){
                if (res.errorCode === missingFileError) {
                    this.props.handleChange(key, null);
                    this.setState({
                        file: null,
                        redirectLink: null,
                        base64URL: null
                    });
                } else {
                    this.setState({
                        // error: res && res.message ? res.message : "Unspecified error",
                        error: res && res.data.deleteImage.message ? res.data.deleteImage.message : "Unspecified error",
                    });
                    this.props.resetFilesItem()
                }
            } else {    
                this.fileInputRef.current.value = null;
                this.props.handleChange(key, null);
                this.setState({
                    file: null,
                    redirectLink: null,
                    base64URL: null,
                    error: null
                });
                this.props.resetFilesItem()
            }
        });
    }

    validateSelectedFile(event) {
        this.setState({isBusy: true});
        let selectedFile = event.currentTarget.files[0];
        const fileSize = selectedFile.size / 1000000; //mb

        if (fileSize > 20){
            this.setState({error:'Maximum file size exceeded'});
            this.setState({isBusy: false});
            return;
        }; 
        
        this.getBase64(selectedFile).then(result => {
            selectedFile["base64"] = result;
            this.setState({
                error: null,
            },() => this.upload(selectedFile));
        });
    }

    render() {
        const {data, label, name, disabled, className, deleted, viewMode = false, link, fileType, uploadManually, handleChangeInput,path} = this.props;
        const {isBusy} = this.state;
        //const value =  this.state.file ? this.state.file : null;
let value = null;

if (this.state.file && this.state.file.name) {
  let fileName = this.state.file.name;

  // Extract filename from URL if needed
  if (fileName.startsWith("http")) {
    const urlParts = fileName.split("/");
    fileName = urlParts[urlParts.length - 1].split("?")[0];
  }

  // Decode URI and remove .pdf extension
  const fileNameWithoutExt = decodeURIComponent(fileName.replace(/\.pdf$/i, "").trim());

  // If it starts with a long hash followed by an underscore, extract the part after that
  const hashPattern = /^[a-f0-9]{32,}_(.+?)(?:_[^_]+)?$/i;
  const match = fileNameWithoutExt.match(hashPattern);

  if (match && match[1]) {
    value = match[1].trim(); // Extracted actual filename from hash
  } else {
    value = fileNameWithoutExt; // Use full file name (e.g., dummy_xSCi4 or getval_Si2aP)
  }
  if(value){
    value = decodeURIComponent(value)
  }
}
        return (
            <div className={`file-container ${className}`}>
                {
                    uploadManually ?
                        <Input
                            className="Website_column_item"
                            type="text"
                            valueType="text"
                            name={name}
                            label={label}
                            value={data[name]}
                            disabled={disabled}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                        />
                    :
                        <React.Fragment>
                            {
                                label &&
                                <label className={`file-label ${disabled ? 'disabled' : ''}`}>{label}</label>
                            }
                            <div className='file-input-container'>
                                <div className="file-text-container">
                                    {
                                        !value ?
                                            <span className={disabled ? 'disabled':''}>No {fileType} selected</span>
                                            :
                                            !viewMode &&
                                            <span className={disabled ? 'disabled':''}>{value.substring(0, 20) + `...`}</span>
                                    }
                                    {
                                        viewMode && value &&
                                        <div className={`file-view ${disabled ? 'disabled': ''}${deleted ? ' file-view-mode-deleted' : ''}`}>
                                            <Link target='_blank'
                                                disabled={disabled}
                                                className="green" 
                                                to={path}>
                                                {value.substring(0, 20) + `...`}
                                            </Link>
                                        </div>
                                    }
                                    {  this.state.error &&
                                        <span className="error">{this.state.error}</span>
                                    }
                                </div>
                                {
                                    !viewMode &&
                                    <div className='file-wrapper'>
                                        <input className='hidden' type="file" ref={this.fileInputRef} accept={fileType === fileTypes.Photo ? "image/png, image/jpeg, image/jpg, .svg" : ".pdf"} onChange={this.validateSelectedFile} disabled={disabled} />
                                        <input className={`button-new ${!value ? 'positive':'negative'} ${disabled ? 'inactive' : ''}`}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                               disabled={disabled}
                                               type="button"
                                               value={`${!isBusy ? !value ?'Choose' : 'Remove': ''} ${!isBusy ? fileType: ''}`}
                                               onClick={!value ? () => this.fileInputRef.current.click() : () => this.remove(name)} />
                                               {isBusy && (
                                                <div
                                                style={{
                                                    position: "absolute",
                                                    width: "20px",
                                                    height: "20px",
                                                    border: "2px solid transparent",
                                                    borderTop: "2px solid #fff",
                                                    borderRadius: "50%",
                                                    animation: "spin 1s linear infinite",
                                                    marginLeft: "64px",
                                                }}
                                                />
                                            )}

                                    </div>
                                }
                            </div>
                        </React.Fragment>
                }
            </div>
        )
    }
}   
